import React from 'react';

const DeleteWellConnection = ({ flagVisibleWell, dataConnectionWell, id, deleteWellCoupling, deleteWellFob, deleteWellCable }) => {
 
  return (
    <div style={{ justifyContent: 'center' }}>
    <label style={{ color: '#dfab01', display: flagVisibleWell ? 'block' : 'none', fontSize: '18px' }}>Связи</label>

    {flagVisibleWell && dataConnectionWell.length > 0 && (
      <>
        {dataConnectionWell.some(item => item.couplingLocationId !== null) && (
          <div className="divStartEndCableModal" style={{ marginTop: '10px' }}>
            <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src="./сoupling.png" alt="вектор" />
            <label style={{ color: '#dfab01', fontSize: '18px' }}>Муфта</label>
            <hr className="horizontalLine2Modal" />
            {dataConnectionWell.map((item, index) =>
              item.couplingLocationId !== null && (
                <div className="divBodyConnectModal" key={index}>
                  <span style={{ fontWeight: 'bold' }}>ID: {item.couplingLocationId}</span>
                  <br />
                  <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.couplingLatitude}, {item.couplingLongitude}</span>
                  <br />
                  <button className="buttonIsEditDialog" style={{ width: '80px' }} onClick={() => deleteWellCoupling(id, item.couplingLocationId)}>Удалить</button>
                </div>
              )
            )}
          </div>
        )}
      </>
    )}

    {flagVisibleWell && dataConnectionWell.length > 0 && (
      <>
        {dataConnectionWell.some(item => item.fobLocationId !== null) && (
          <div className="divStartEndCableModal" style={{ marginTop: '10px' }}>
            <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src="./fob.png" alt="вектор" />
            <label style={{ color: '#dfab01', fontSize: '18px' }}>Фоб</label>
            <hr className="horizontalLine2Modal" />
            {dataConnectionWell.map((item, index) =>
              item.fobLocationId !== null && (
                <div className="divBodyConnectModal" key={index}>
                  <span style={{ fontWeight: 'bold' }}>ID: {item.fobLocationId}</span>
                  <br />
                  <span style={{ fontSize: '14px', color: '#202020' }}>Координаты: {item.fobLatitude}, {item.fobLongitude}</span>
                  <br />
                  <button className="buttonIsEditDialog" style={{ width: '80px' }} onClick={() => deleteWellFob(id, item.fobLocationId)}>Удалить</button>
                </div>
              )
            )}
          </div>
        )}
      </>
    )}

    {flagVisibleWell && dataConnectionWell.length > 0 && (
      <>
        {dataConnectionWell.some(item => item.highwayLineId !== null) && (
          <div className="divStartEndCableModal" style={{ marginTop: '10px' }}>
            <img style={{ marginLeft: '10px', marginRight: '10px', width: '30px', height: '30px' }} src="./cable.png" alt="вектор" />
            <label style={{ color: '#dfab01', fontSize: '18px' }}>Кабель</label>
            <hr className="horizontalLine2Modal" />
            {dataConnectionWell.map((item, index) =>
              item.highwayLineId !== null && (
                <div className="divBodyConnectModal" key={index}>
                  <span style={{ fontWeight: 'bold' }}>ID: {item.highwayLineId}</span>
                  <br />
                  <button className="buttonIsEditDialog" style={{ width: '80px' }} onClick={() => deleteWellCable(id, item.highwayLineId)}>Удалить</button>
                </div>
              )
            )}
          </div>
        )}
      </>
    )}
  </div>
);
};

export default DeleteWellConnection;